import { Transport } from 'shared/api/tours/flights/model'

export function getRouteInfo(transports: Transport[]): string {
  const allSegments = transports

  if (allSegments.length === 0) return ''

  const cities: string[] = []

  if (allSegments[0]?.departure?.[0]?.town) {
    cities.push(allSegments[0].departure[0].town)
  }

  allSegments.forEach((seg) => {
    const city = seg.arrival?.[0]?.town
    if (city) cities.push(city)
  })

  const route = cities.filter((city, i, arr) => i === 0 || city !== arr[i - 1])

  return route.join(' — ')
}
